export default "__VITE_PUBLIC_ASSET__54620754__"